// Composables
import { createRouter, createWebHistory } from 'vue-router'
import { checkPermissions } from '@/helper/permissionsv2'
import { checkModules } from '@/helper/modulesv2'
import { ModulosEnum } from '@/enums/ModulosEnum'
import { useSessionStore } from '@/stores/components/sessionStore'
import { EmpresaTipoEnum } from '@/enums/EmpresaTipoEnum'
import { PermissionEnum } from '@/enums/PermissionEnum'

const AND = 'AND'
const OR = 'OR'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
  {
    path: '/login',
    component: () => import('@/views/login/NovoLoginScreen.vue'),
    name: 'Login',
    meta: { requiresAuth: false, guestOnly: true },
  },
  {
    path: '/envio-documentos',
    component: () =>
      import('@/views/envioDocumentos/EnvioDocumentosScreen.vue'),
    name: 'EnvioDocumentosScreen',
    meta: { requiresAuth: true },
  },
  {
    path: '/envio-documentos/selfie',
    component: () =>
      import('@/views/envioDocumentos/SelfieTemporariaScreen.vue'),
    name: 'SelfieTemporariaScreen',
    meta: { requiresAuth: false },
  },
  {
    path: '/login_novo',
    component: () => import('@/views/login/NovoLoginScreen.vue'),
    name: 'Login2',
    meta: { requiresAuth: false },
  },
  {
    path: '/cadastro/:parceiroUrl?',
    component: () =>
      import('@/views/cadastros/novoUsuario/NewNovoUsuarioScreen.vue'),
    name: 'NewNovoUsuario',
    meta: { requiresAuth: false, guestOnly: true },
  },
  {
    path: '/cobranca/:uuid',
    component: () =>
      import('@/views/financeiro/EfetuarPagamento/EfetuarPagamento.vue'),
    name: 'EfetuarPagamento',
    meta: { requiresAuth: false },
  },
  {
    path: '/inadimplencia-debito/:id',
    component: () => import('@/views/financeiro/InadimplenciaDebitos.vue'),
    name: 'Inadimplencia-debito',
    meta: { requiresAuth: false },
  },
  {
    path: '/analise-de-credito/:uuid',
    component: () =>
      import('@/views/analiseCredito/AnaliseImpressaoScreen.vue'),
    name: 'AnaliseCreditoImpressao',
    meta: { requiresAuth: false },
  },
  {
    path: '/serasa/:uuid',
    component: () => import('@/views/serasa/SerasaImpressaoScreen.vue'),
    name: 'SerasaImpressao',
    meta: { requiresAuth: false },
  },
  {
    path: '/negativacao/:uuid',
    component: () =>
      import('@/views/negativacao/NegativacaoImpressaoScreen.vue'),
    name: 'Negativacaompressao',
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    component: () => import('@/components/layout/default/AppView.vue'),
    //
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/HomeScreen.vue'),
        meta: {
          requiresAuth: true,
          pageTitle: 'Home',
          pageIcon: 'mdi-home',
        },
      },
      {
        path: '/planos',
        name: 'Planos',
        component: () => import('@/views/planos/Planos.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.PLANOS],
          permissions: [PermissionEnum.PLANOS_VISUALIZAR],
          pageTitle: 'Planos',
        },
      },
      {
        path: '/planos/informacoes-de-cobranca',
        name: 'Pagamento do plano',
        component: () =>
          import('@/views/planos/pagamento/ColetaInformacoesPagamento.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.PLANOS, ModulosEnum.ADMINISTRACAO],
          modules_operator: AND,
          pageTitle: 'Dados de Cobrança do Plano',
          pageIcon: 'mdi-card',
          permissions: [
            PermissionEnum.PLANOS_VISUALIZAR,
            PermissionEnum.ADMINISTRACAO_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/higienizacao',
        name: 'Higienizacao',
        component: () => import('@/views/higienizacao/HigienizacaoScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.HIGIENIZACAO],
          pageTitle: 'Higienização',
          pageIcon: 'mdi-account-check',
          permissions: [PermissionEnum.HIGIENIZACAO_VISUALIZAR],
        },
      },
      {
        path: '/administracao/grupos',
        name: 'Grupos',
        component: () => import('@/views/administracao/GruposScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.CADASTROS_GRUPOS, ModulosEnum.ADMINISTRACAO],
          modules_operator: AND,
          pageTitle: 'Administração | Grupos',
          pageIcon: 'mdi-home-group',
          permissions: [
            PermissionEnum.CADASTROS_CADASTROSGRUPOS_VISUALIZAR,
            PermissionEnum.ADMINISTRACAO_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/dev/adicionar-saldo',
        name: 'AdicionarSaldoScreen',
        component: () => import('@/views/dev/AdicionarSaldoScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN_ADICIONAR_SALDO],
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINADICIONARSALDO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/dev/comunicacao-em-lote/whatsapp-templates',
        name: 'ComunicacaoEmLoteWhatsappTemplates',
        component: () =>
          import('@/views/dev/ComunicacaoEmLoteWhatsappTemplates.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_COMUNICACAO_EM_LOTE_WHATSAPP_DEV,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINCOMUNICACAOEMLOTEWHATSAPPDEV_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/dev/run-scheduled-jobs',
        name: 'RunScheduledJobsScreen',
        component: () => import('@/views/dev/RunScheduledJobsScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_ADICIONAR_SALDO,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINADICIONARSALDO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      /*{
        path: '/dev/crud/servicos',
        name: 'CrudServicosScreen',
        component: () => import('@/views/dev/CrudServicosScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN, ModulosEnum.SUPERADMIN_ADICIONAR_SALDO], //TODO: Criar modulo só pra essa seção
          modules_operator: AND,
          permissions: [PermissionEnum.SUPERADMIN_SUPERADMINADICIONARSALDO_VISUALIZAR, PermissionEnum.SUPERADMIN_VISUALIZAR],
          permissions_operator: AND,
        },
      },*/
      {
        path: '/gestao/dashboard',
        component: () => import('@/views/gestao/Dashboard.vue'),
        name: 'DashboardGestao',
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN, ModulosEnum.SUPERADMIN_GESTAO],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/clientes',
        name: 'GestaoClientes',
        component: () => import('@/views/gestao/Clientes.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_EMPRESAS,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINEMPRESAS_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/log-criacao-conta',
        name: 'GestaoLogCriacaoConta',
        component: () => import('@/views/gestao/LogCriacaoConta.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_LOG_CRIACAO_CONTA,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINLOGCRIACAOCONTA_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/historico-pagamentos',
        name: 'HistoricoBoletos',
        component: () => import('@/views/gestao/HistoricoBoletos.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_HISTORICO_BOLETOS,
            ModulosEnum.SUPERADMIN,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINHISTORICOBOLETOS_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/historico-recargas',
        name: 'HistoricoRecargas',
        component: () => import('@/views/gestao/HistoricoRecarga.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_HISTORICO_BOLETOS,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINHISTORICOBOLETOS_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/inatividade-clientes',
        name: 'InatividadeClientes',
        component: () => import('@/views/gestao/InatividadeClientes.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_ATIVIDADE_CLIENTES,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINATIVIDADECLIENTES_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/comissao-x-vendas',
        name: 'ComissaoXVendas',
        component: () => import('@/views/gestao/ComissaoXVendas.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_COMISSAO_VENDAS,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINCOMISSAOVENDAS_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/movimentacao-por-produto',
        name: 'MovimentacaoPorProduto',
        component: () => import('@/views/gestao/MovimentacaoPorProduto.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_MOVIMENTACAO_PRODUTO,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINMOVIMENTACAOPRODUTO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/envio-notificacoes',
        name: 'EnvioNotificacoes',
        component: () => import('@/views/gestao/EnvioNotificacoes.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_ENVIO_DE_NOTIFICACOES,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINENVIODENOTIFICACOES_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/api',
        name: 'GestaoApi',
        component: () => import('@/views/gestao/GestaoApi.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_API,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINAPI_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/historico-notificacoes',
        name: 'HistoricoNotificacoes',
        component: () => import('@/views/gestao/HistoricoNotificacoes.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_ENVIO_DE_NOTIFICACOES,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINENVIODENOTIFICACOES_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/conciliacao-bancaria',
        name: 'ConciliacaoBancaria',
        component: () => import('@/views/gestao/ConciliacaoBancaria.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_CONCILIACAO_BANCARIA,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINCONCILIACAOBANCARIA_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/gestao/controle-consumo-fornecedor',
        name: 'ControleConsumoFornecedor',
        component: () => import('@/views/gestao/ControleConsumoFornecedor.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_CONTROLE_CONSUMO_FORNECEDOR,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINCONTROLECONSUMOFORNECEDOR_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      /*{
        path: '/gestao/notas-fiscais',
        name: 'NotasFiscaisGestao',
        component: () => import('@/views/notasFiscais/NotasFiscaisGestao.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN, ModulosEnum.SUPERADMIN_GESTAO, ModulosEnum.SUPERADMIN_CONTROLE_CONSUMO_FORNECEDOR],
          modules_operator: AND,
          permissions: [PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR, PermissionEnum.SUPERADMIN_SUPERADMINCONTROLECONSUMOFORNECEDOR_VISUALIZAR, PermissionEnum.SUPERADMIN_VISUALIZAR],
          permissions_operator: AND,
        },
      },*/
      {
        path: '/gestao/campanhas',
        name: 'CampanhasGestao',
        component: () => import('@/views/gestao/CampanhasGestao.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN,
            ModulosEnum.SUPERADMIN_GESTAO,
            ModulosEnum.SUPERADMIN_CAMPANHAS,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINGESTAO_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINCAMPANHAS_VISUALIZAR,
            PermissionEnum.SUPERADMIN_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/administracao/usuarios',
        name: 'Usuarios',
        component: () => import('@/views/administracao/UsuariosScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.ADMINISTRACAO, ModulosEnum.CADASTROS_USUARIOS],
          modules_operator: AND,
          permissions: [
            PermissionEnum.ADMINISTRACAO_VISUALIZAR,
            PermissionEnum.CADASTROS_CADASTROSUSUARIOS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Administração | Usuários',
          pageIcon: 'mdi-account-supervisor',
        },
      },
      {
        path: '/api',
        name: 'Api',
        component: () => import('@/views/api/ApiScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN, ModulosEnum.SUPERADMIN_API],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINAPI_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/base-de-conhecimento',
        name: 'BaseConhecimento',
        component: () =>
          import('@/views/baseconhecimento/BaseConhecimento.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.BASE_DE_CONHECIMENTO,
            ModulosEnum.BASE_DE_CONHECIMENTO_CATEGORIAS,
            ModulosEnum.BASE_DE_CONHECIMENTO_ARTIGOS,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.BASEDECONHECIMENTO_VISUALIZAR,
            PermissionEnum.BASEDECONHECIMENTO_BASEDECONHECIMENTOCATEGORIAS_VISUALIZAR,
            PermissionEnum.BASEDECONHECIMENTO_BASEDECONHECIMENTOARTIGOS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Base de conhecimento',
          pageIcon: 'mdi-school-outline',
        },
      },
      {
        path: '/base-de-conhecimento/categoria/:uuid',
        name: 'BaseConhecimentoCategoria',
        component: () =>
          import('@/views/baseconhecimento/BaseConhecimentoCategoria.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.BASE_DE_CONHECIMENTO,
            ModulosEnum.BASE_DE_CONHECIMENTO_CATEGORIAS,
            ModulosEnum.BASE_DE_CONHECIMENTO_ARTIGOS,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.BASEDECONHECIMENTO_VISUALIZAR,
            PermissionEnum.BASEDECONHECIMENTO_BASEDECONHECIMENTOCATEGORIAS_VISUALIZAR,
            PermissionEnum.BASEDECONHECIMENTO_BASEDECONHECIMENTOARTIGOS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Base de conhecimento',
          pageIcon: 'mdi-school-outline',
        },
      },
      {
        path: '/base-de-conhecimento/:uuid',
        name: 'BaseConhecimentoInterna',
        component: () =>
          import('@/views/baseconhecimento/BaseConhecimentoInterna.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.BASE_DE_CONHECIMENTO,
            ModulosEnum.BASE_DE_CONHECIMENTO_CATEGORIAS,
            ModulosEnum.BASE_DE_CONHECIMENTO_ARTIGOS,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.BASEDECONHECIMENTO_VISUALIZAR,
            PermissionEnum.BASEDECONHECIMENTO_BASEDECONHECIMENTOCATEGORIAS_VISUALIZAR,
            PermissionEnum.BASEDECONHECIMENTO_BASEDECONHECIMENTOARTIGOS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Base de conhecimento',
          pageIcon: 'mdi-school-outline',
        },
      },
      {
        path: '/gestao/leads',
        name: 'CadastrosEmpresas',
        component: () =>
          import('@/views/cadastros/empresas/EmpresasScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN, ModulosEnum.SUPERADMIN_EMPRESAS],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINEMPRESAS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Administração | Leads',
          pageIcon: 'mdi-domain',
        },
      },
      /*{
        path: '/gestao/empresas/cadastrar',
        name: 'CadastroEmpresa',
        component: () => import('@/views/cadastros/empresas/EmpresasCadastroScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN_EMPRESAS],
          pageTitle: 'Administração | Empresas | Nova empresa',
          pageIcon: 'mdi-domain',
        },
      },*/
      {
        path: '/cadastros/empresas/editar/:uuid?',
        name: 'EditarEmpresa',
        component: () =>
          import('@/views/cadastros/empresas/EmpresasEdicaoScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.SUPERADMIN_EMPRESAS,
            ModulosEnum.CADASTROS_EMPRESAS,
            ModulosEnum.ADMINISTRACAO,
          ],
          modules_operator: OR,
          permissions: [
            PermissionEnum.SUPERADMIN_SUPERADMINEMPRESAS_VISUALIZAR,
            PermissionEnum.CADASTROS_CADASTROSEMPRESAS_VISUALIZAR,
            PermissionEnum.ADMINISTRACAO_VISUALIZAR,
          ],
          permissions_operator: OR,
          pageTitle: 'Administração | Empresas | Editar empresa',
          pageIcon: 'mdi-domain',
        },
      },
      {
        path: '/cadastros/:tipo_cliente',
        name: 'CadastrosClientes',
        component: () =>
          import('@/views/cadastros/clientes/ClientesScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.CADASTROS, ModulosEnum.CADASTROS_CLIENTES],
          modules_operator: AND,
          permissions: [
            PermissionEnum.CADASTROS_VISUALIZAR,
            PermissionEnum.CADASTROS_CADASTROSCLIENTES_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/cadastros/:tipo_cliente/cadastrar',
        name: 'CadastroCliente',
        component: () =>
          import('@/views/cadastros/clientes/ClientesCadastroScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.CADASTROS, ModulosEnum.CADASTROS_CLIENTES],
          modules_operator: AND,
          permissions: [
            PermissionEnum.CADASTROS_VISUALIZAR,
            PermissionEnum.CADASTROS_CADASTRAR,
            PermissionEnum.CADASTROS_CADASTROSCLIENTES_CADASTRAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/cadastros/:tipo_cliente/editar/:uuid',
        name: 'EditarCliente',
        component: () =>
          import('@/views/cadastros/clientes/ClientesEdicaoScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.CADASTROS, ModulosEnum.CADASTROS_CLIENTES],
          modules_operator: AND,
          permissions: [
            PermissionEnum.CADASTROS_VISUALIZAR,
            PermissionEnum.CADASTROS_CADASTROSCLIENTES_VISUALIZAR,
            PermissionEnum.CADASTROS_CADASTROSCLIENTES_VISUALIZAR,
          ],
          permissions_operator: AND,
        },
      },
      {
        path: '/cadastros/especies-pagamento',
        name: 'EspeciesPagamento',
        component: () =>
          import('@/views/cadastros/especiesPagamento/EspeciesPagamento.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.CADASTROS,
            ModulosEnum.CADASTROS_ESPECIE_PAGAMENTO,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.CADASTROS_VISUALIZAR,
            PermissionEnum.CADASTROS_CADASTROSESPECIEPAGAMENTO_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Espécies de pagamento',
          pageIcon: 'mdi-account-credit-card-outline',
        },
      },
      {
        path: '/cadastros/categorias',
        name: 'FinanceiroCategorias',
        component: () =>
          import('@/views/cadastros/categorias/CategoriasScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.CADASTROS, ModulosEnum.CADASTROS_CATEGORIAS],
          modules_operator: AND,
          permissions: [
            PermissionEnum.CADASTROS_VISUALIZAR,
            PermissionEnum.CADASTROS_CADASTROSCATEGORIAS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Categorias',
          pageIcon: 'mdi-clipboard-list-outline',
        },
      },
      {
        path: '/serasa',
        component: () => import('@/views/serasa/SerasaScreen'),
        name: 'SerasaScreen',
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SERASA],
          permissions: [PermissionEnum.SERASA_VISUALIZAR],
          pageTitle: 'Busca Serasa',
          pageIcon: 'mdi-file-search-outline',
        },
      },
      {
        path: '/negativacao',
        component: () => import('@/views/negativacao/NegativacaoScreen'),
        name: 'NegativacaoScreen',
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SERASA, ModulosEnum.SERASA_NEGATIVACAO],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SERASA_VISUALIZAR,
            PermissionEnum.SERASA_SERASANEGATIVACAO_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Negativação',
          pageIcon: 'mdi-file-cancel-outline',
        },
      },
      {
        path: '/planos/produtos-e-servicos',
        component: () => import('@/views/planos/ProdutosEServicosScreen.vue'),
        name: 'ProdutosEServicosScreen',
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.PLANOS],
          modules_operator: AND,
          permissions: [
            PermissionEnum.PLANOS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Produtos e Serviços',
          pageIcon: 'mdi-file-search-outline',
        },
      },
      {
        path: '/planos/extrato-de-uso',
        component: () => import('@/views/planos/ExtratoDeUsoScreen.vue'),
        name: 'ExtratoDeUsoScreen',
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.PLANOS],
          modules_operator: AND,
          permissions: [
            PermissionEnum.PLANOS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Extrato de Uso',
          pageIcon: 'mdi-file-search-outline',
        },
      },
      /*{
        path: '/canais',
        name: 'Canais',
        component: () => import('@/views/Canais/CanaisScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.CADASTROS, ModulosEnum.CADASTROS_CANAIS],
          modules_operator: AND,
          permissions: [PermissionEnum.CADASTROS_VISUALIZAR, PermissionEnum.CADASTROS_CANAIS_VISUALIZAR],
          permissions_operator: AND,
          pageTitle: 'Canais',
          pageIcon: 'mdi-access-point',
        },
      },*/
      {
        path: '/financeiro/fluxo-de-caixa',
        name: 'FluxoDeCaixa',
        component: () => import('@/views/financeiro/FluxoDeCaixa.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.GESTAO_FLUXO_DE_CAIXA,
            ModulosEnum.GESTAO_FLUXO_DE_CAIXA_FLUXO_CAIXA,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.GESTAOFLUXODECAIXA_VISUALIZAR,
            PermissionEnum.GESTAOFLUXODECAIXA_GESTAOFLUXODECAIXAFLUXOCAIXA_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Fluxo de caixa',
          pageIcon: 'mdi-format-list-bulleted-type',
        },
      },
      {
        path: '/financeiro/comunicacao-cobranca',
        name: 'ComunicacaoCobranca',
        component: () => import('@/views/financeiro/Inadimplencia.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.GESTAO_FLUXO_DE_CAIXA,
            ModulosEnum.GESTAO_FLUXO_DE_CAIXA_FLUXO_CAIXA,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.GESTAOFLUXODECAIXA_VISUALIZAR,
            PermissionEnum.GESTAOFLUXODECAIXA_GESTAOFLUXODECAIXAFLUXOCAIXA_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Comunicação de Cobrança',
          pageIcon: 'mdi-message-alert-outline',
        },
      },
      {
        path: '/financeiro/caixas',
        name: 'FinanceiroCaixas',
        component: () => import('@/views/financeiro/CaixasScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.GESTAO_FLUXO_DE_CAIXA,
            ModulosEnum.GESTAO_FLUXO_DE_CAIXA_CAIXAS,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.GESTAOFLUXODECAIXA_VISUALIZAR,
            PermissionEnum.GESTAOFLUXODECAIXA_GESTAOFLUXODECAIXACAIXAS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Caixas',
          pageIcon: 'mdi-archive-eye',
        },
      },
      {
        path: '/financeiro/caixas/:uuid',
        name: 'FinanceiroCaixasDetalhe',
        component: () => import('@/views/financeiro/CaixasInterna.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.GESTAO_FLUXO_DE_CAIXA,
            ModulosEnum.GESTAO_FLUXO_DE_CAIXA_CAIXAS,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.GESTAOFLUXODECAIXA_VISUALIZAR,
            PermissionEnum.GESTAOFLUXODECAIXA_GESTAOFLUXODECAIXACAIXAS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Caixas | Livro Caixa',
          pageIcon: 'mdi-notebook-edit',
        },
      },
      {
        path: '/notas-fiscais',
        name: 'NotasFiscais',
        component: () => import('@/views/notasFiscais/NotasFiscais.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.NOTAS_FISCAIS],
          permissions: [PermissionEnum.NOTASFISCAIS_VISUALIZAR],
          pageTitle: 'Notas fiscais',
          pageIcon: 'mdi-file-document-outline',
        },
      },
      {
        path: '/notas-fiscais/configuracao',
        name: 'NotasFiscaisConfiguracao',
        component: () =>
          import('@/views/notasFiscais/dialogs/NotasFiscaisConfiguracoes.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.NOTAS_FISCAIS],
          permissions: [PermissionEnum.NOTASFISCAIS_VISUALIZAR],
        },
      },
      {
        path: '/relatorios/geral',
        name: 'RelatorioGeral',
        component: () => import('@/views/relatorios/RelatorioGeral.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.RELATORIOS],
          permissions: [PermissionEnum.RELATORIOS_VISUALIZAR],
          pageTitle: 'Relatórios | Geral',
        },
      },
      {
        path: '/relatorios/caixa',
        name: 'RelatorioCaixas',
        component: () => import('@/views/relatorios/RelatorioCaixas.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.RELATORIOS],
          permissions: [PermissionEnum.RELATORIOS_VISUALIZAR],
          pageTitle: 'Relatórios | Caixas',
        },
      },
      {
        path: '/relatorios/contas-a-pagar',
        name: 'RelatorioContasPagar',
        component: () => import('@/views/relatorios/RelatorioContasPagar.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.RELATORIOS],
          permissions: [PermissionEnum.RELATORIOS_VISUALIZAR],
          pageTitle: 'Relatórios | Contas a Pagar',
        },
      },
      {
        path: '/relatorios/contas-a-receber',
        name: 'RelatorioContasReceber',
        component: () =>
          import('@/views/relatorios/RelatorioContasReceber.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.RELATORIOS],
          permissions: [PermissionEnum.RELATORIOS_VISUALIZAR],
          pageTitle: 'Relatórios | Contas a Receber',
        },
      },
      {
        path: '/relatorios/repasses',
        name: 'RelatorioRepasses',
        component: () =>
          import('@/views/relatorios/RelatorioRepasses.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.RELATORIOS, ModulosEnum.ADMINISTRACAO],
          modules_operator: AND,
          permissions: [PermissionEnum.RELATORIOS_VISUALIZAR, PermissionEnum.ADMINISTRACAO_VISUALIZAR],
          permissions_operator: AND,
          pageTitle: 'Relatórios | Repasses',
        },
      },
      {
        path: '/monetizacao/planos',
        name: 'PlanosScreen',
        component: () => import('@/views/monetizacao/planos/PlanosScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN, ModulosEnum.SUPERADMIN_PLANOS],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINPLANOS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Monetização | Planos',
        },
      },
      {
        path: '/parceiros',
        name: 'ParceirosScreen',
        component: () => import('@/views/parceiros/ParceirosScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN, ModulosEnum.SUPERADMIN_PARCEIROS],
          modules_operator: AND,
          permissions: [
            PermissionEnum.SUPERADMIN_VISUALIZAR,
            PermissionEnum.SUPERADMIN_SUPERADMINPARCEIROS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Parceiros',
        },
      },
      /*{
        path: '/monetizacao/planos/cadastrar',
        name: 'AdicionarPlanosScreen',
        component: () => import('@/views/monetizacao/planos/AdicionarPlanosScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN, ModulosEnum.SUPERADMIN_PLANOS],
          modules_operator: AND,
          permissions: [PermissionEnum.SUPERADMIN_VISUALIZAR, PermissionEnum.SUPERADMIN_SUPERADMINPLANOS_CADASTRAR],
          permissions_operator: AND,
          pageTitle: 'Monetização | Planos',
        },
      },*/
      /*{
        path: '/monetizacao/planos/editar/:uuid',
        name: 'EditarPlanosScreen',
        component: () => import('@/views/monetizacao/planos/AdicionarPlanosScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.SUPERADMIN, ModulosEnum.SUPERADMIN_PLANOS],
          modules_operator: AND,
          permissions: [PermissionEnum.SUPERADMIN_VISUALIZAR, PermissionEnum.SUPERADMIN_SUPERADMINPLANOS_VISUALIZAR],
          permissions_operator: AND,
          pageTitle: 'Monetização | Planos',
        },
      },*/
      {
        path: '/monetizacao/tarifas',
        name: 'TarifasScreen',
        component: () => import('@/views/monetizacao/planos/TarifasScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.PLANOS],
          permissions: [PermissionEnum.PLANOS_VISUALIZAR],
          pageTitle: 'Tarifas',
        },
      },
      {
        path: '/extrato',
        name: 'SaldoScreen',
        component: () => import('@/views/monetizacao/SaldoScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.ADMINISTRACAO, ModulosEnum.CADASTROS_EMPRESAS],
          modules_operator: AND,
          permissions: [
            PermissionEnum.ADMINISTRACAO_VISUALIZAR,
            PermissionEnum.CADASTROS_CADASTROSEMPRESAS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Extrato',
        },
      },
      {
        path: '/automatizacao-cobranca',
        name: 'ReguaCobranca',
        component: () => import('@/views/reguaCobranca/ReguaScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.AUTOMACAO_COMUNICACAO_COBRANCAS],
          permissions: [
            PermissionEnum.AUTOMACAOCOMUNICACAOCOBRANCAS_VISUALIZAR,
          ],
          pageTitle: 'Automatização de Cobrança',
        },
      },
      {
        path: '/automatizacao-cobranca/:id',
        name: 'ReguaCobrancaAcoes',
        component: () => import('@/views/reguaCobranca/ReguaAcoes.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.AUTOMACAO_COMUNICACAO_COBRANCAS],
          permissions: [
            PermissionEnum.AUTOMACAOCOMUNICACAOCOBRANCAS_VISUALIZAR,
          ],
          pageTitle: 'Automatização de Cobrança | Ações',
        },
      },
      /*{
        path: '/analise-de-credito',
        name: 'AnaliseCredito',
        component: () => import('@/views/analiseCredito/AnaliseScreen.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.ANALISE_DE_CREDITO],
          pageTitle: 'Análise de crédito',
          pageIcon: 'mdi-account-search',
        },
      },*/
      {
        path: '/comunicacao-em-lote/whatsapp',
        name: 'ComunicacaoEmLoteWhatsApp',
        component: () => import('@/views/comunicacaoEmLote/whatsapp/index.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.COMUNICACAO_EM_LOTE,
            ModulosEnum.COMUNICACAO_EM_LOTE_WHATSAPP,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.COMUNICACAOEMLOTE_VISUALIZAR,
            PermissionEnum.COMUNICACAOEMLOTE_COMUNICACAOEMLOTEWHATSAPP_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Comunicação em Lote | Whatsapp',
        },
      },
      {
        path: '/comunicacao-em-lote/email',
        name: 'ComunicacaoEmLoteEmail',
        component: () => import('@/views/comunicacaoEmLote/email/index.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.COMUNICACAO_EM_LOTE,
            ModulosEnum.COMUNICACAO_EM_LOTE_EMAIL,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.COMUNICACAOEMLOTE_VISUALIZAR,
            PermissionEnum.COMUNICACAOEMLOTE_COMUNICACAOEMLOTEEMAIL_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Comunicação em Lote | Email',
        },
      },
      {
        path: '/comunicacao-em-lote/sms',
        name: 'ComunicacaoEmLoteSms',
        component: () => import('@/views/comunicacaoEmLote/sms/index.vue'),
        meta: {
          requiresAuth: true,
          modules: [
            ModulosEnum.COMUNICACAO_EM_LOTE,
            ModulosEnum.COMUNICACAO_EM_LOTE_SMS,
          ],
          modules_operator: AND,
          permissions: [
            PermissionEnum.COMUNICACAOEMLOTE_VISUALIZAR,
            PermissionEnum.COMUNICACAOEMLOTE_COMUNICACAOEMLOTESMS_VISUALIZAR,
          ],
          permissions_operator: AND,
          pageTitle: 'Comunicação em Lote | SMS',
        },
      },
      /*{
        path: '/financeiro/antecipacao-de-recebiveis',
        name: 'AntecipacaoRecebiveis',
        component: () =>
          import('@/views/antecipacaoRecebiveis/AntecipacaoRecebiveis.vue'),
        meta: {
          requiresAuth: true,
          modules: [ModulosEnum.ANTECIPACAO_RECEBIVEIS],
          pageTitle: 'Antecipação de recebíveis',
        },
      }*/
    ],
  },
]

// Importante: Ao criar uma rota, acesse o arquivo AppBar.vue e adicione o nome dela na função updatePageTitle

/**
 * @copyright (c) 2024, SETH TOTAL SISTEMAS. All rights reserved.
 * @description Esta função verifica se a empresa tem acesso a um módulo específico com base no ID da empresa ou na razão social.
 * Ela retorna um objeto contendo informações sobre se a verificação deve retornar um booleano, o valor booleano em si e os módulos
 * aos quais a empresa tem acesso.
 *
 * MUST BE REVIEWED IN THE FUTURE FOR BETTER IMPLEMENTATION, CURRENTLY MADE TO ATTEND SOME SPECIFIC REQUESTS OF CLIENTS,
 * BUT IS NOT BE THE BEST WAY TO HANDLE THIS IN SECURITY TERMS.
 * @todo improve
 *
 */
const canCompanyidAccess = (company_id, company_razao_social, uuid_emp_id) => {
  var enviroment = import.meta.env.VITE_ENVIRONMENT

  var company_id_access_list = [
    //TEMPORARIO - CLIENTES
    {
      uuid_emp_id: '5e6e657d-b0c7-46be-a825-422d2207aa1c',
      modules: [ModulosEnum.GESTAO_FLUXO_DE_CAIXA_FLUXO_CAIXA],
    }, //PLANETA
    {
      uuid_emp_id: '8f66c79a-0236-4836-b7d9-f68c3fc418f4',
      modules: [
        ModulosEnum.SERASA,
        ModulosEnum.SERASA_NEGATIVACAO,
        ModulosEnum.HIGIENIZACAO,
      ],
    }, //MONTE SIAO COOPERATIVA DE ENERGIA
    {
      uuid_emp_id: 'fb22f2a6-808e-4129-8fe9-26c87d07cdf1',
      modules: [ModulosEnum.SERASA, ModulosEnum.SERASA_NEGATIVACAO],
    }, //SION GESTAO E CONSULTORIA EM ENERGIA SA
    {
      uuid_emp_id: 'bb006a59-5456-42d1-b9cf-2eb1d1095342',
      modules: [
        ModulosEnum.SERASA,
        ModulosEnum.SERASA_CONSULTA_BASICA,
        ModulosEnum.SERASA_CONSULTA_AVANCADA,
      ],
    }, //ISABELA S.R.
    {
      uuid_emp_id: '043a60fe-d72e-4547-abe2-2ccffc3a9d52',
      modules: [
        ModulosEnum.SERASA,
        ModulosEnum.SERASA_CONSULTA_BASICA,
        ModulosEnum.SERASA_CONSULTA_AVANCADA,
      ],
    }, //PLANO AGRONEGOCIO LTDA
    {
      uuid_emp_id: '8ae1cf96-525b-4cdd-904f-f59f5bf6525c',
      modules: [ModulosEnum.SERASA, ModulosEnum.SERASA_NEGATIVACAO],
    }, //ADAGRO

    //PERMANENTE - SETH
    { uuid_emp_id: '7244d5af-6b8b-4f2e-b929-f69ec246a5c1', modules: ['*'] }, //ÁGIL
    { uuid_emp_id: '2e2234bc-9fdf-41f7-8482-ab839b4a5d71', modules: ['*'] }, //HENN
    { uuid_emp_id: '0d4d8f94-1bdc-4e34-88e8-3fde2389c105', modules: ['*'] }, //FURUKA
    { uuid_emp_id: '6a3daeaa-a3bd-40b9-9921-835cf6dbf87f', modules: ['*'] }, //FURUKA - HOMOLOG
  ]

  var shoudReturnBool = false
  var returnValueBool = false
  var modules = []

  if (
    enviroment != 'development' ||
    enviroment == '' ||
    enviroment == null ||
    enviroment == undefined
  ) {
    shoudReturnBool = true
    returnValueBool = company_id_access_list.some(
      (item) =>
        item.id === company_id ||
        item.razao_social === company_razao_social ||
        item.uuid_emp_id === uuid_emp_id
    )
    modules =
      company_id_access_list.find(
        (item) =>
          item.id === company_id ||
          item.razao_social === company_razao_social ||
          item.uuid_emp_id === uuid_emp_id
      )?.modules ?? []
  }

  return {
    shoudReturn: shoudReturnBool,
    returnValue: returnValueBool,
    modules: modules,
  }
}

const getCurrentCampaignsList = () => {
  const rawCampaings = useSessionStore()?.currentCampaings

  if (Array.isArray(rawCampaings)) {
    return rawCampaings
  }

  if (rawCampaings && typeof rawCampaings === 'object') {
    return Object.values(rawCampaings)
  }

  return []
}

const hasCampaignModuleAccess = (modules = []) => {
  const requestedModules = Array.isArray(modules) ? modules : [modules]
  if (!requestedModules.length) {
    return false
  }

  const normalizedRequestedModules = requestedModules.map((moduleCode) =>
    String(moduleCode ?? '').toUpperCase()
  )

  return getCurrentCampaignsList().some((campaign) => {
    if (!campaign || typeof campaign !== 'object') {
      return false
    }

    const campaignModules = campaign.modulos
    if (!Array.isArray(campaignModules)) {
      return false
    }

    return campaignModules.some((campaignModule) =>
      normalizedRequestedModules.includes(
        String(campaignModule?.codigo ?? '').toUpperCase()
      )
    )
  })
}

let sessionBootstrapPromise = null

const ensureSessionInitializedForGuards = async () => {
  const localToken = localStorage.getItem('token')
  if (!localToken) {
    return
  }

  const sessionStore = useSessionStore()
  const hasUserData = Boolean(sessionStore?.userData)
  const hasLoadedCampaigns = sessionStore?.currentCampaings !== null

  if (hasUserData && hasLoadedCampaigns) {
    return
  }

  if (!sessionBootstrapPromise) {
    sessionBootstrapPromise = sessionStore
      .initialize()
      .catch((error) => {
        console.error('Erro ao inicializar sessão no guard:', error)
      })
      .finally(() => {
        sessionBootstrapPromise = null
      })
  }

  await sessionBootstrapPromise
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

const getRouteModules = (meta = {}) => {
  if (Array.isArray(meta.modules)) {
    return meta.modules
  }

  if (Array.isArray(meta.module)) {
    return meta.module
  }

  if (typeof meta.modules === 'string') {
    return [meta.modules]
  }

  if (typeof meta.module === 'string') {
    return [meta.module]
  }

  return []
}

const routeRequiresRestrictedAccess = (modules = []) => {
  return modules.some((module) => {
    const moduleName = String(module ?? '').toLowerCase()
    return (
      moduleName.startsWith('superadmin') ||
      module === ModulosEnum.ADMINISTRACAO
    )
  })
}

const globalCanAccess = ({ to, from, routeRecord }) => {
  let canAccess = true
  let admin = useSessionStore()?.userData?.permissoes?.some((perm) =>
    perm.toLowerCase().startsWith('administracao')
  )
  
  // A verificação de hasPlan não é mais usada para bloquear as rotas, 
  // mas mantida em variável caso necessite injetar uso posterior
  let hasPlan = !useSessionStore()?.isSubscriptionDefault
  
  let superadmin = useSessionStore()?.userData?.permissoes?.some((perm) =>
    perm.toLowerCase().startsWith('superadmin')
  )
  let userSeth = useSessionStore()?.userData?.usuario?.usu_seth ?? false
  let companyGeneralAccess =
    (useSessionStore()?.currentEmpresa?.emp_tipo ??
      EmpresaTipoEnum.NORMAL.valueOf()) ==
    EmpresaTipoEnum.ACESSO_GERAL.valueOf()

  if (userSeth) {
    useSessionStore().setGiveAllAccess(true)
  }

  if (userSeth && superadmin && admin) {
    return true
  }

  for (const index in routeRecord.children) {
    const item = routeRecord.children[index]
    if (item.name === to.name) {
      const metaKey = item.meta
      const routeModules = getRouteModules(metaKey)

      if (routeModules.length > 0) {
        const has_campaign_perm = hasCampaignModuleAccess(routeModules)
        if (has_campaign_perm) {
          return true
        }

        var company_id_can_access_obj = canCompanyidAccess(
          useSessionStore()?.currentEmpresa?.emp_id,
          useSessionStore()?.currentEmpresa?.emp_razao_social,
          useSessionStore()?.currentEmpresa?.uuid_emp_id
        )
        if (company_id_can_access_obj.shoudReturn) {
          if (company_id_can_access_obj.returnValue) {
            if (company_id_can_access_obj.modules.includes('*')) {
              useSessionStore().setGiveAllAccess(true)
            }

            if (routeModules instanceof Array) {
              var has_module_access = routeModules.find(
                (modulo) =>
                  company_id_can_access_obj.modules.includes(modulo) ||
                  company_id_can_access_obj.modules.includes('*')
              )
              if (has_module_access) {
                return true
              }
            }
          }
        }

        const has_admin_module_access =
          admin &&
          routeModules.includes(ModulosEnum.ADMINISTRACAO)

        // NOVA REGRA DE NEGÓCIO: Avalia apenas as permissões de acesso restrito (Admin/Superadmin)
        let requires_superadmin = false
        let requires_admin = false

        if (routeModules instanceof Array) {
          const superadminModules = routeModules.filter((modulo) =>
            modulo.toLowerCase().startsWith('superadmin')
          )
          // Com operador OR qualquer módulo da lista já libera a rota, então
          // exigir superadmin só faz sentido se não houver outra via de acesso.
          requires_superadmin =
            metaKey.modules_operator === OR
              ? superadminModules.length === routeModules.length
              : superadminModules.length > 0
          requires_admin = routeModules.includes(ModulosEnum.ADMINISTRACAO)
        }

        // Bloqueia se a página exige superadmin mas o usuário não é
        if (requires_superadmin && !superadmin) {
          return false
        }

        // Bloqueia se a página exige admin mas o usuário não é
        if (requires_admin && !has_admin_module_access) {
          return false
        }

        // Caso não exija superadmin ou admin, libera o acesso da rota, independente do plano
        canAccess = true

      } else {
        canAccess = true
      }
    }
  }

  return canAccess
}

router.beforeEach(async (to, from, next) => {
  const sessionStore = useSessionStore()
  let token = sessionStore.token || localStorage.getItem('token')
  const rejectNavigation = () => {
    if (from?.matched?.length) {
      return next(false)
    }

    return next({ path: '/', replace: true })
  }

  if (token && !sessionStore.userData) {
    await sessionStore.initialize()
  }

  token = sessionStore.token || localStorage.getItem('token')
  const loggedout = !token

  // Verificação para rotas que requerem autenticação
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (loggedout) {
      sessionStore.clearSession()
      localStorage.removeItem('user')
      return next({ name: 'Login' })
    }
  }

  if (!loggedout) {
    await ensureSessionInitializedForGuards()
  }

  // Verificar módulo e permissões para rotas
  const isDefaultPlan = sessionStore?.isSubscriptionDefault
  const routeModules = getRouteModules(to.meta)
  const shouldEnforceStrictChecks = routeRequiresRestrictedAccess(routeModules)

  // Aplica verificação estrita apenas para áreas restritas (Admin/Superadmin).
  // Isso evita redirecionamentos indevidos para Home durante a troca de páginas comuns.
  if (
    !isDefaultPlan &&
    shouldEnforceStrictChecks &&
    routeModules.length > 0 &&
    !checkModules(routeModules, to.meta.modules_operator) &&
    !hasCampaignModuleAccess(routeModules)
  ) {
    return rejectNavigation()
  }

  // Para rotas comuns, o acesso visual é liberado pelo novo fluxo.
  // Permissões continuam sendo validadas somente nas áreas restritas.
  if (
    !isDefaultPlan &&
    shouldEnforceStrictChecks &&
    to.meta.permissions &&
    !checkPermissions(to.meta.permissions, to.meta.permissions_operator)
  ) {
    return rejectNavigation()
  }

  if (to.meta.guestOnly && token) {
    return next({ path: '/', replace: true })
  }

  for (const routeRecord of to.matched) {
    const canAccessFn =
      typeof routeRecord.meta?.canAccess === 'function'
        ? routeRecord.meta.canAccess
        : globalCanAccess

    let allowed = canAccessFn({ to, from, routeRecord })
    if (!allowed) {
      return rejectNavigation()
    }
  }

  next()
})

// Guard para definir o title da página automaticamente
router.afterEach((to) => {
  let pageTitle = 'Sistema Seth'

  if (to.meta?.pageTitle) {
    pageTitle = to.meta.pageTitle
  } else {
    // Fallbacks para rotas dinâmicas
    switch (to.name) {
      case 'CadastrosClientes':
        pageTitle = to.params.tipo_cliente
          ? to.params.tipo_cliente[0].toUpperCase() +
            to.params.tipo_cliente.slice(1)
          : 'Clientes'
        break
      case 'CadastroCliente':
        if (to.params.tipo_cliente == 'fornecedores') {
          pageTitle = 'Fornecedor | Cadastrar'
        } else if (to.params.tipo_cliente == 'clientes') {
          pageTitle = 'Cliente | Cadastrar'
        } else {
          pageTitle = 'Cadastrar'
        }
        break
      case 'EditarCliente':
        if (to.params.tipo_cliente == 'fornecedores') {
          pageTitle = 'Fornecedor | Editar'
        } else if (to.params.tipo_cliente == 'clientes') {
          pageTitle = 'Cliente | Editar'
        } else {
          pageTitle = 'Editar'
        }
        break
    }
  }

  document.title = `Seth - ${pageTitle}`
})

export default router